// The reply the panel writes once the office has booked for the patient.
//
// Booking the second half of a set replaced the first half's sentence, so
// the patient was told about the doctor and not the labs. Every appointment
// booked from this panel in this sitting is named, in one sentence. Dates
// read "Tue, Oct 13 at 10:00 AM" like every other text a patient gets.
import { offerWhen } from './offerMessage';

export interface BookedForReply {
  serviceName?: string | null;
  providerName?: string | null;
  date?: string | null;
  time?: string | null;
}

const clean = (v?: string | null): string => String(v || '').trim();
const article = (name: string): string => (/^[aeiou]/i.test(name) ? 'an' : 'a');

const one = (b: BookedForReply): string => {
  const service = clean(b.serviceName) || 'appointment';
  const provider = clean(b.providerName);
  return `${article(service)} ${service}${provider ? ` with ${provider}` : ''} on ${offerWhen({ date: b.date, time: b.time })}`;
};

export function bookedReplyText(patientName: string, bookings: BookedForReply[]): string {
  const first = clean(patientName).split(/\s+/)[0] || 'there';
  const parts = bookings.map(one);
  const what = parts.length <= 1 ? parts[0] || 'an appointment'
    : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
  const it = parts.length <= 1 ? 'it' : (parts.length === 2 ? 'either' : 'any of them');
  return `Hi ${first}, you're booked for ${what}. Let us know if you need to change ${it}.`;
}
